module.exports = __webpack_public_path__ + "img/P6.6514877a.png";